import styled from 'styled-components'
import Card from './card.jsx'
import CardProm from './cardProm.jsx'
import {useParams} from "react-router-dom"
import {useSelector,useDispatch} from 'react-redux';
import cerrar from "../../imgs/cerrar.png"
import {open} from "../../redux/actions.js"
import Backdrop from '@mui/material/Backdrop';
import logoFarmasis from "../../imgs/farmasis.png"
import { useState,useEffect } from 'react';




let ContainerCards=styled.div`
	display:flex;
	height:84vh;
	flex-direction:row;
	flex-wrap: wrap;
	align-items: center;
	justify-content:space-evenly;
	background-image:url(${logoFarmasis});
	background-repeat:no-repeat;
	background-size: contain;
	background-position:center;
	overflow:auto;
	&::-webkit-scrollbar{
		background-color:white;
		width:5px};
	::-webkit-scrollbar-thumb{
		background:#01578c;
		border-radius:25px};
	::-webkit-scrollbar:horizontal{display:none}
`
let ContainerCard=styled.div`
	margin:45px
`;

let Video=styled.video`
	max-height:74vh;
	max-width:70vw;	
	border-radius:25px;
		
`
let Cerrar=styled.img` 
	max-width:85px;
	width:6vw;
	min-width:40px;
	position:absolute;
	right:6vw;
	@media (max-width: 768px) {
    	right:2vw;
  	};
 `;

 let NotFound=styled.div`
 	position:absolute;
 	top:45px;
 	left:35px;
 	font-family: 'Poppins';
 	color:red;
 	font-size:22px
  `;

export default function Cards(props){
	let grupo=useParams().grupo;
	let data=useSelector(state=>state.data);
	const url=useSelector(state=>state.urlVideo);
	const openState=useSelector(state=>state.open);
	const busqueda=useSelector(state=>state.busqueda);
	const id=useSelector(state=>state.id);
	const dispatch=useDispatch();
	let [videos,setVideos]=useState();
	let [filtro,setFiltro]=useState();


	useEffect(()=>{		
		if(data){ setVideos(data.filter( ele=>Object.keys(ele)[0]===grupo )[0][grupo].sort(function (a, b) { return a.name.localeCompare(b.name) }) ) };
	},[data,grupo]);


	useEffect(()=>{	

		if(busqueda && videos ){
				let temp=[];
				videos.forEach(ele=>{if(ele.name.includes(busqueda)||ele.descrip.includes(busqueda)){temp.push(ele)}  } );
				temp.length>0?setFiltro(temp):setFiltro();
							
			}else {setFiltro(videos)};
			

	},[grupo,videos,busqueda])

	

	 	

	const handleClose=()=>{
		let video=document.getElementById(id);		
		video.pause();
	 	dispatch(open(false))
	 	
	 };

	
	

   return(
		<ContainerCards>
			{openState?<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={openState}  > 
					
		  			<Video  id={id} autoPlay={true} src={`${url}`}  controls/>
		  			<Cerrar src={cerrar} onClick={handleClose}/>
     	 	</Backdrop>:null}

			{filtro?
				filtro.map(ele=>ele.destacado===1?< ContainerCard><CardProm key={ele.ID}  video={ele}/></ContainerCard>:< ContainerCard><Card key={ele.ID}  video={ele}/></ContainerCard>)
				:<NotFound><b>{`No se encontro tutorial con nombre o descripcion que contenga la palabra :  "${busqueda}" , dentro del contenido para : ${grupo}` }</b></NotFound> }
			
		</ContainerCards>
 	)	
}